import React, { useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Link, useNavigate } from 'react-router-dom';
import './BreadcrumbBlock.scss'
import { IPagination } from '../../pages/Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { NodeEvent } from '../../pages/Customers/CustomerGroup/Component/SideBar';

interface Props {

  items: Array<any>;
  title: string | React.ReactNode;
  idBackLink?: number | undefined;
  backLink?: string;
  historyBack?: any;
  description?: string;
  className?: string;
  actions?: React.ReactNode;

  //restore
  firstPage?: string
  inforNodeEvent?: NodeEvent
  restorePagination?: IPagination
  restoreDataFilterList?: any

  brandId?: number;
  dataFilter?: any;
  unitIdDefault?: number;
  type?: string;
  brandName?: string

  // state cụ thể của nơi gọi, ưu tiên dùng làm state điều hướng quay lại khi có
  backState?: Record<string, unknown>
}

const BreadcrumbBlock: React.FC<Props> = ({
  idBackLink,
  items, title, backLink, description,
  className = '', historyBack = '',
  actions,
  firstPage, inforNodeEvent,
  restorePagination, restoreDataFilterList,

  brandId,
  dataFilter,
  unitIdDefault,
  type,
  brandName,
  backState
}) => {
  const navigate = useNavigate()
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);
  const goBack = () => {
    if (typeof window !== 'undefined' && window.history && window.history.length > 1) {
      return navigate(-1);
    }
    return navigate(
      {
        pathname: firstPage ? firstPage : backLink,
      },
      {
        state: backState ?? {
          id: idBackLink,
        }
      }
    );
  }
  return (
    <div className={`app-breadcrumb-block ${className}`}>
      <Breadcrumb
        items={items}
      />

      <div className="app-breadcrumb-title">
        {
          backLink && (
            <Link
              className="icon"
              to={ firstPage ?? backLink}
              state={backState ?? {
                id: idBackLink,
                inforNodeEvent,
                restorePagination,
                restoreDataFilterList,
                brandId,
                dataFilter,
                unitIdDefault,
                type,
                brandName
              }} // truyền state nếu cần giữ pagination
            >
              <ArrowLeftOutlined />
            </Link>
          )
        }
        {
          historyBack
          && <div className="icon cursor-pointer" onClick={() => goBack()}><ArrowLeftOutlined /></div>
        }
        <div className="title">{title}</div>
        {
          description
          && <div className="description">{description}</div>
        }
        {actions && <div className="custom-page-css ml-auto flex gap-2">{actions}</div>}
      </div>
    </div >
  );
}

export default BreadcrumbBlock;
